import { render, staticRenderFns } from "./upload-voucher.vue?vue&type=template&id=34ff5744"
import script from "./upload-voucher.vue?vue&type=script&lang=ts"
export * from "./upload-voucher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports